var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3","fill":"","pills":"","card":""}},[_c('b-tab',{attrs:{"title":"Followers (1)"}},[_c('Followers')],1),_c('b-tab',{attrs:{"title":"Following (1)"}},[_c('Following')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }